export type BaseUrlInputs = {
  /** process.env.AIFANS_API_URL — inlined by Parcel at build time; undefined for staging/prod builds */
  envApiUrl?: string
  /** location.protocol, e.g. 'https:' */
  proto: string
  /** location.hostname, lowercased */
  host: string
  /** location.port */
  port: string
  /** localStorage 'api_url' value (host only), or null */
  override?: string | null
  /** location.origin */
  origin: string
}

// Precedence (most explicit wins):
//   1. localStorage override (runtime, user-initiated support tool)
//   2. AIFANS_API_URL build-time env var (per-deployment default; set only for previews)
//   3. hostname heuristics (existing staging/prod behavior)
//   4. location.origin fallback
export function resolveBaseUrl(i: BaseUrlInputs): string {
  if (i.override) return `${i.proto}//${i.override}`

  const env = i.envApiUrl?.trim()
  if (env) {
    const noSlash = env.replace(/\/+$/, '')
    // AIFANS_API_URL is hand-set per deployment; tolerate a missing scheme so a
    // scheme-less value doesn't silently break HTTP (relative path) and WS (wss://) derivation.
    return /^https?:\/\//i.test(noSlash) ? noSlash : `https://${noSlash}`
  }

  if (i.port === '1234' || i.port === '3001') return `${i.proto}//${i.host}:3001`
  if (i.host === 'agnai.chat') return `${i.proto}//prd-api.agnai.chat`
  if (i.host === 'prd-assets.agnai.chat') return `${i.proto}//edge-api.agnai.chat`
  if (i.host === 'dev.agnai.chat' || i.host === 'dev-assets.agnai.chat')
    return `${i.proto}//api.agnai.chat`
  if (i.host === 'stg.agnai.chat') return `${i.proto}//stg-api.agnai.chat`
  return i.origin
}
